import { connect } from 'react-redux'
import ApplicationsComponent from '../../../components/employer/applications/applications.component'
import {
  getApplicantDetails,
  getAreaOfWork,
  getOfferFromLightEntre,
  loadProfileStart,
  applicationPageChange,
  getAssignments
} from '../../../actions/employer'

const mapStateToProps = (state) => {
  // There are 2 types of records
  // 1. Assignment agreement is directly offered to the light entrepreneurs
  // 2. The light entrepreneurs apply an assignment
  const mergedApplications = mergeApplications(
    state.applications.applications,
    state.applications.offeredFromLightEntre.filter(
      // Filter out the applications that are not offered to light entrepreneurs
      (el) =>
        el?.application_status !== 'Unprocessed application' &&
        el?.application_status !== 'Employer rejected'
    )
  )

  return {
    state,
    applications: mergedApplications,
    selectedRows: state.applications.selectedRows,
    applicationDetails: state.applications.applicationDetails,
    isFilter: state.applications.isFilter,
    filterApplicants: state.applications.filterApplicants,
    offeredFromLightEntre: state.applications.offeredFromLightEntre,
    selected: state.applications.selected,
    pageSize: state.applications.pageSize
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
    getApplicantDetails: () => dispatch(getApplicantDetails()),
    getAreaOfWork: () => dispatch(getAreaOfWork()),
    getOfferFromLightEntre: () => dispatch(getOfferFromLightEntre()),
    loadProfileStart: () => dispatch(loadProfileStart()),
    applicationPageChange: (selected) =>
      dispatch(applicationPageChange(selected)),
    getAssignments: () => dispatch(getAssignments())
  }
}

const mergeApplications = (applications, offeredAssignments) => {
  const offerAssignment_assignment_id = new Set(
    offeredAssignments.map((el) => el?.application_id)
  )
  const filterApplication = applications.filter(
    (el) => !offerAssignment_assignment_id.has(el.application_id)
  )

  return [...filterApplication, ...offeredAssignments]
}

const ApplicationsContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(ApplicationsComponent)

export default ApplicationsContainer
